'use client';

import dynamic from 'next/dynamic';
import { useCurrentUser } from '@/src/lib/hooks/query';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { canUseListingAdminTools } from './listingAdminToolsPanel.utils';

const ListingAdminToolsPanelImpl = dynamic(() =>
  import('./ListingAdminToolsPanel').then((mod) => mod.ListingAdminToolsPanel),
);

/**
 * Role-gates BEFORE the dynamic mount so non-admin visitors never download the
 * panel chunk; the panel keeps its own internal href/role guard.
 */
export function ListingAdminToolsPanelLoader({ listing }: { listing: PropertyDetailListing }) {
  const { data: currentUser } = useCurrentUser();
  if (!canUseListingAdminTools(currentUser)) return null;

  return <ListingAdminToolsPanelImpl listing={listing} />;
}
